<template>
  <div class="login">
    <div class="login-content">
      <div class="login-title">
        <h3 class="display-1 mb-3 font-weight-medium">
          {{ this.$t('login.title') }}
        </h3>
        <template>
          <div class="login-subtitle">
            {{ this.$t('login.subtitle') }}
            <a
              target="_blank"
              href="http://animalki.eu"
            >
              {{ $t('login.animalkiApp') }}
            </a>
          </div>
        </template>
      </div>
      <LoginForm />
    </div>
  </div>
</template>


<script>
import { mapState } from 'vuex'
import { LOGGED_USER_KEY } from '../store/types/user.types'
import LoginForm from '../components/LoginForm'

export default {
  name: 'LoginView',
  components: {
    LoginForm,
  },
  computed: {
    ...mapState({
      loggedUser: state => state.user[LOGGED_USER_KEY],
    }),
  },
  created() {
    if (this.loggedUser) this.$router.push('/visits')
  },
}
</script>
<style lang="stylus">
.login {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-self: center;
    justify-content: center;
  }

.login-title {
  margin-bottom: 2em;
  a {
    text-decoration: none;
  }
}
@media only screen and (max-width: 480px) {
  .login-subtitle {
    padding: 0 1em;
  }
}
</style>
